import React from "react";
import { Link } from "react-router-dom";
import PaginaEsito from "./esito/PaginaEsito";

// Pagina di esito in italiano, con lo stesso aspetto delle altre pagine di esito
const Error403 = () => (
   <PaginaEsito titolo="Accesso negato" variante="danger">
      <p>Non hai il permesso di vedere questa pagina.</p>
      <Link className="btn btn-primary btn-add" to="/dashboard">
         Torna alla home
      </Link>
   </PaginaEsito>
);

export default Error403;
